module.exports = __webpack_public_path__ + "static/media/twitter.fdec90bf.svg";